import { render, staticRenderFns } from "./ResourceContributors.vue?vue&type=template&id=096cdc12&scoped=true"
import script from "./ResourceContributors.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceContributors.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResourceContributors.vue?vue&type=style&index=0&id=096cdc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096cdc12",
  null
  
)

export default component.exports